import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
// import RSVPForm from "./RSVPForm registartion closed";
import RSVPForm from "./RSVPForm";

const SummerMeet = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#rsvp-form") {
      // Retry a few times in case images/layout take a moment to paint
      const attemptScroll = (attemptsLeft) => {
        const formElement = document.getElementById("rsvp-form");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth" });
        } else if (attemptsLeft > 0) {
          setTimeout(() => attemptScroll(attemptsLeft - 1), 300);
        }
      };

      // Start the scroll attempt sequence natively using CSS scroll-margin-top
      setTimeout(() => attemptScroll(3), 100);
    } else if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.hash]);

  // Variants for animation
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 120,
      },
    }),
  };

  // Add `\n` where you want a line break
  const headingText = "Strengthening Connections Across the MSB Community";

  const title = "Summer Members Meet 2026";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Welcome - Summer Members Meet 2026 | MSB Association</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Welcome - Summer Members Meet 2026 | MSB Association " />
        <meta property="og:description" content="" />

        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section className="page_header text-center section_decoration overflow-hidden bg-image-css">
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column", // stack lines vertically
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n") // Convert "/n" to actual line breaks
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // ensure words wrap on smaller screens
                      justifyContent: "center",
                      gap: "0.4rem"
                    }}
                  >
                    {line.split(" ").map((word, wordIndex) => (
                      <span
                        key={`word-${lineIndex}-${wordIndex}`}
                        style={{
                          display: "inline-block",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {word.split("").map((letter, charIndex) => {
                          const uniqueIndex = lineIndex * 50 + wordIndex * 15 + charIndex;
                          return (
                            <motion.span
                              key={`char-${lineIndex}-${wordIndex}-${charIndex}`}
                              custom={uniqueIndex}
                              initial="hidden"
                              animate="visible"
                              variants={letterVariants}
                              style={{
                                display: "inline-block",
                              }}
                            >
                              {letter}
                            </motion.span>
                          );
                        })}
                      </span>
                    ))}
                  </div>
                ))}
            </motion.h1>

            <div className="d-flex justify-content-center align-items-center mb-4 mt-2 flex-wrap" style={{ color: "#fff" }}>
              <span className="me-2" style={{ fontSize: "18px" }}>Sponsored by</span>
              <a href="https://peratera.com/" target="_blank" rel="noreferrer">
                <img
                  // src="/assets/images/clear-junction-logo.svg" 
                  // src="https://peratera.com/icons/logo.svg" 
                  src="/assets/images/peratera-logo.svg"
                  alt="Peratera Logo"
                  className="img-fluid"
                  style={{ height: "40px", objectFit: "contain", maxWidth: "200px" }}
                />
              </a>
            </div>

            {/* <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    lineHeight: "25px",
                    color: "#FBA834",
                  }}
                >
                  Date & venue will be announced soon.
                  <br />
                </span>
              </li>
            </ul> */}
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    lineHeight: "25px",
                    color: "#FBA834",
                  }}
                >
                  Friday, 26 June 2026 | 6:00 PM BST Onwards
                  <br />
                  <br />
                  📍 1864 Rooftop Bar &amp; Kitchen <br />
                  6th Floor,
                  John Lewis,
                  300 Oxford Street,
                  London WC1 1DX
                </span>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content">
              <h2 className="item_details_heading text-center">
                {headingText.split("").map((char, i) => {
                  if (char === "\n") {
                    return <br key={`br-${i}`} />;
                  }
                  return (
                    <motion.span
                      key={`${char}-${i}`}
                      custom={i}
                      initial="hidden"
                      animate="visible"
                      variants={headingVariants}
                    >
                      {char}
                    </motion.span>
                  );
                })}
              </h2>
              <p>
                The MSB Association is excited to invite you to the <strong>Summer Members Meet 2026</strong>, sponsored by <strong>Peratera</strong>, taking place on <strong>Friday, 26th June 2026</strong>, at <strong>6th Floor, John Lewis, 300 Oxford Street, London WC1 1DX</strong>.
              </p>

              <p>
                Following the tremendous success of the <strong>Annual Members Meet 2026</strong>, this summer gathering aims to continue building stronger industry relationships, encouraging collaboration, and creating valuable networking opportunities within the MSB sector.
              </p>

              <p>
                Join us for an engaging evening of industry dialogue, shared insights, and high-value networking with professionals shaping the future of the regulated payments and remittance industry.
              </p>

              <h5 className="mb-3">About Peratera</h5>
              <p>
                We are proud to have <strong>Peratera</strong> as our sponsor for the Summer Members Meet 2026. As a modern payment platform supporting global businesses with secure cross-border payment solutions, Peratera shares our commitment to innovation, compliance excellence, and industry growth. Their partnership reflects a shared vision of strengthening collaboration and supporting the evolving needs of the MSB ecosystem.
              </p>

              <h5 className="mb-3">Why Attend?</h5>
              <ul className="mb-4">
                <li className="mb-2">Network with MSB business owners, compliance professionals, and industry leaders</li>
                <li className="mb-2">Build valuable relationships across the MSB and fintech ecosystem</li>
                <li className="mb-2">Exchange insights on current market trends and regulatory developments</li>
                <li className="mb-2">Explore collaboration and partnership opportunities</li>
                <li className="mb-2">Be part of meaningful discussions shaping the future of the MSB sector</li>
              </ul>

              <p className="mb-4">
                This event is designed to encourage informed conversation, stronger industry engagement, and practical networking opportunities for regulated businesses across the sector.
              </p>

              <h5 className="mb-3">A Community That Continues to Grow</h5>
              <p className="mb-2">
                As many of you know, the MSB Association Annual Members Meet 2026 was a tremendous success, bringing together industry leaders, partners, and members for an unforgettable evening of collaboration and networking.
              </p>
              <p className="mb-2">
                If you missed that event, this is your opportunity to experience the energy, connections, and conversations that make the MSB Association community truly unique.
              </p>
              <p className="mb-4">
                We look forward to welcoming you.
              </p>

              {/* <h5 className="mb-3">Special Guest:</h5>
              <p>
                We are pleased to share that <strong>representatives from the FCA and HMRC</strong> have been invited to join us for this special evening. Their participation, subject to confirmation, will offer members a valuable opportunity to engage directly with key regulators, gain insight into current supervisory priorities, and better understand evolving compliance expectations.
              </p> */}

              <h5 className="mb-3 mt-4">Member Participation & Subscription</h5>
              <p className="mb-2">
                As a not-for-profit association, the MSB Association depends on the active support of its members to deliver impactful events, advocacy, and industry representation.
              </p>
              <p className="mb-2">
                We kindly request all members to ensure their <strong>annual subscription fee is settled prior to attending</strong>. These contributions help us:
              </p>
              <ul className="mb-4">
                <li>Cover venue and event costs</li>
                <li>Support regulatory engagement</li>
                <li>Deliver member services and initiatives</li>
                <li>Strengthen the collective influence of the MSB sector</li>
              </ul>
              <p className="mb-4">
                Your support ensures the continued growth and credibility of our community.
              </p>

              <h5 className="mb-3 mt-4">RSVP</h5>
              <p className="mb-2">
                Attendance is limited and early confirmation is strongly encouraged.
              </p>
              <p className="mb-2">
                Please complete the registration form below to secure your place at the MSB Association Summer Members Meet 2026.
              </p>
              <p>
                <strong>We look forward to welcoming you.</strong>
              </p>

              <div className="row mb-4 mt-4 align-item-center">
                <div className="col-lg-6 col-md-6 col-12">
                  {/* <h5 className="mb-3">Event Program</h5>
                  <div className="schedule-date">
                    Thursday, 16 April 2026
                  </div>
                  <div className="schedule-card">
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">
                          Welcome Drinks & Registration
                        </h6>
                      </div>
                      <div>6:00 PM – 6:30 PM</div>
                    </div>
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">Welcome Address by the MSB Association Board</h6>
                      </div>
                      <div>6:30 PM – 6:45 PM</div>
                    </div>
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">
                          Discussion Panel
                        </h6>
                      </div>
                      <div>6:50 PM – 7:10 PM</div>
                    </div>
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">
                          Key Note Speaker
                        </h6>
                      </div>
                      <div>7:15 PM – 7:30 PM</div>
                    </div>
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">
                          Networking, Drinks & Refreshments
                        </h6>
                      </div>
                      <div>7:45 PM – 9:00 PM</div>
                    </div>
                  </div> */}

                  <div className="schedule-date mt-4">Venue</div>
                  <div className="schedule-card p-0">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.8959052802597!2d-0.1480405229158971!3d51.51512571013845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761ad4ca8e31f5%3A0xeff180698a7cd0b1!2s1864%20Rooftop%20Bar%20%26%20Kitchen%2C%20Oxford%20Street!5e0!3m2!1sen!2sin!4v1780294128133!5m2!1sen!2sin" width="400" height="300" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    <div className="p-4">
                      <h6 className="fw-bold mb-1">
                        1864 Rooftop Bar &amp; Kitchen,
                      </h6>
                      {/* <p className="mb-1 ">1864 Rooftop Bar &amp; Kitchen,</p> */}
                      <p className="mb-0 ">6th Floor,
                        John Lewis,
                        300 Oxford Street,
                        London WC1 1DX</p>
                    </div>
                  </div>
                </div>
                <hr className="d-block d-sm-none" />
                <div className="col-lg-6 col-md-6 col-12" id="rsvp-form" style={{ scrollMarginTop: "150px" }}>
                  <RSVPForm />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default SummerMeet;
